import React from 'react'
import { useTranslation } from 'react-i18next'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'

export default function SelectedPopup({ count, onCancel, onDelete }) {
  const { t } = useTranslation()

  return (
    <div className="selected-popup">
      <p className="selected-popup__title">{t('Library.deleteModal.selectedPopup.selectedCount', { count })}</p>

      <div className="selected-popup__buttons">
        <SecondaryButton
          text={t('Library.deleteModal.selectedPopup.btnDelete')}
          onClick={onDelete}
          color="navy"
          fullWidth={false}
        />

        <TransparentBgButton
          onClick={onCancel}
          text={t('Library.deleteModal.selectedPopup.btnCancel', { defaultValue: t('common.cancel') })}
          color="navy"
          fullWidth={false}
        />
      </div>
    </div>
  )
}